const API_BASE = 'https://api.dev.auxo.dk/public';

/**
 * Fetch a full collection as a bare array.
 * Best for small collections like services, contact info, and pages.
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${API_BASE}/content/${collectionName}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch collection ${collectionName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Fetch Error (${collectionName}):`, error);
    return [];
  }
}

/**
 * Fetch a collection using the v2 paginated/filtered endpoint.
 */
export async function fetchCollectionV2(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        query.append(key, String(val));
      }
    });
    const queryString = query.toString() ? `?${query.toString()}` : '';
    const response = await fetch(`${API_BASE}/v2/content/${collectionName}${queryString}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch v2 collection ${collectionName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Fetch V2 Error (${collectionName}):`, error);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

/**
 * Fetch a single entry by its slug.
 */
export async function fetchBySlug(slug, lang = 'en') {
  try {
    const url = lang 
      ? `${API_BASE}/by-slug/${lang}/${slug}`
      : `${API_BASE}/by-slug/${slug}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch slug ${slug}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Fetch Slug Error (${slug}):`, error);
    return null;
  }
}

/**
 * Fetch a single entry by its ID.
 */
export async function fetchById(collectionName, entryId) {
  try {
    const response = await fetch(`${API_BASE}/content/${collectionName}/${entryId}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch entry ${entryId} from ${collectionName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Fetch ID Error (${collectionName}/${entryId}):`, error);
    return null;
  }
}
